// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3q-1";
export var movingGradient = "_3q-4";
export var movingGradientBlock = "_3q-2";
export var skeleton = "_3q-0";
export var skeletonText = "_3q-3";